<template>
    <div class='m-form__section m-form__section--first'>
        <div class='m-form__heading'>
            <h3 class='m-form__heading-title'>
                Module Options
            </h3>
        </div>
        <div class="m-form__group form-group" v-if="softdelete == 1">
            <label for="">
                Soft Delete
            </label>
            <div class="m-radio-inline">
                <label class="m-radio">
                    <input type="radio" name="example_3" value="1" v-model="options.softdeletes" v-on:change="updateOptions">
                    Yes
                    <span></span>
                </label>
                <label class="m-radio">
                    <input type="radio" name="example_3" value="0" v-model="options.softdeletes" v-on:change="updateOptions">
                    No
                    <span></span>
                </label>
            </div>
            <span class="m-form__help">
                Some help text goes here
            </span>
        </div>
        <div class="m-form__group form-group">
            <table class="table table-bordered table-hover">
                <tr>
                    <th>#</th>
                    <th>Edit Resource</th>
                    <th>List Resource</th>
                    <th>Searchable</th>
                    <th>Search Type</th>
                    <th>Search label</th>
                </tr>
                <tr v-for="(item, index) in options.extra" v-bind:key="index">
                    <td>
                        {{item.name}}
                    </td>
                    <td>
                        <label class="m-checkbox">
                            <input type="checkbox" v-model="item.resource" v-on:change="updateOptions">
                            <span></span>
                        </label>
                    </td>
                    <td>
                        <label class="m-checkbox">
                            <input type="checkbox" v-model="item.show_list" v-on:change="updateOptions">
                            <span></span>
                        </label>
                    </td>
                    <td>
                        <label class="m-checkbox">
                            <input type="checkbox" v-model="item.searchColumns" v-on:change="updateOptions">
                            <span></span>
                        </label>
                    </td>
                    <td>
                        <select class="form-control" v-model="item.searchType" v-on:change="updateOptions">
                            <option value="text">Text</option>
                            <option value="interval">Interval</option>
                            <option value="date_interval">Date Interval</option>
                            <option value="select">Select</option>
                        </select>
                    </td>
                    <td>
                        <input type="text" class="form-control" v-model="item.searchColumnLabels" v-on:keyup="updateOptions">
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Options',
  props: {
    options: {
      type: Object,
      required: true
    },
    inputs: {
      required: true
    },
    softdelete: {
      required: true
    }
  },
  methods: {
    updateOptions: function () {
      this.$emit('updateOptions', this.options)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/module/Options.vue